module.exports = __webpack_public_path__ + "static/expertsender-logo-fa00b4d024ff9ad91ca04de4046db7ad.gif";